import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppPaymentViewComponent } from '../components/view/upp-view';
import { UppStripePayButtonComponent } from '../components/stripe/pay-button/upp-button';
import { UppPaymentLicenseComponent } from '../components/stripe/pay-license/upp-license';
import { UppPaymentTicketComponent } from '../components/stripe/pay-ticket/upp-ticket';
import { UppPaymentConnectComponent } from '../components/stripe/pay-connect/upp-connect';

@NgModule({
    declarations: [
        UppPaymentViewComponent,
        UppStripePayButtonComponent,
        UppPaymentLicenseComponent,
        UppPaymentTicketComponent,
        UppPaymentConnectComponent,
    ],
    imports: [
        CommonModule,
        IonicModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule,
    ],
    exports: [
        UppPaymentViewComponent,
        UppStripePayButtonComponent,
        UppPaymentLicenseComponent,
        UppPaymentTicketComponent,
        UppPaymentConnectComponent,
    ],
    providers: [],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
})
export class FeaturePaymentModule {}
